import SearchBar from 'global/search/SearchBar';

class CustomerServiceSearchForm extends SearchBar {
	constructor() {
		super('[data-customer-service-search-bar]');
		this.form = document.querySelector('[data-id="customerServiceSearchForm"]');
		this.input = this.form.querySelector('[data-search-bar-input]');
		this.form.addEventListener('submit', e => this.validateForm(e));
	}

	validateForm(e) {
		if (this.input && this.input.value.length === 0) {
			e.preventDefault();
		}
	}
}

export default CustomerServiceSearchForm;
